import * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

import * as colors from '../../../colors'

/**
 * Transform data from
 * {@link ents.core.display.chart.data.Of<ents.core.display.chart.Type.ScatterChart>} to
 * {@link chartJs.ChartData<'scatter'>}
 */
export function getData(
  data: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Scatter>,
): chartJs.ChartData<'scatter'> {
  // TODO: support multiple charts in one widget
  const { values } = data

  const palette = colors.createPalette(ents.core.display.chart.Type.Scatter)

  const datasets: chartJs.ChartDataset<'scatter'>[] =
    values?.map(({ color: _color, name, points }, i) => {
      const nameOrIndex = name ?? i.toString()
      return {
        // 00 = 0% opacity (fully transparent)
        // 1A = ~10% opacity
        // 33 = ~20% opacity
        // 4D = ~30% opacity
        // 66 = ~40% opacity
        // 80 = ~50% opacity
        // 99 = ~60% opacity
        // B3 = ~70% opacity
        // CC = ~80% opacity
        // E6 = ~90% opacity
        // FF = 100% opacity (fully opaque)
        // Added alpha channel to background color for transparency (80 = ~50% opacity)
        backgroundColor: `${_color ?? palette.getOrAssignColorFor(nameOrIndex)}80`,
        data:
          points?.map(point => ({
            // Scatter chart accepts only number for value on x-axis
            x: Number.isNaN(Number(point.x)) ? 0 : Number(point.x),
            y: point.y ?? 0,
          })) ?? [],
        hoverBackgroundColor:
          _color ?? palette.getOrAssignColorFor(nameOrIndex),
        label: name,
        pointHoverRadius: 8,
        pointRadius: 6,
      }
    }) ?? []

  return { datasets }
}
